import { render, staticRenderFns } from "./MfcSort.vue?vue&type=template&id=0be6af23&"
import script from "./MfcSort.vue?vue&type=script&lang=js&"
export * from "./MfcSort.vue?vue&type=script&lang=js&"
import style0 from "./MfcSort.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports